<template><v-app-bar
      :color="maincolor"
      dark
      class="navbar"
    >
      <v-toolbar-items
      class="navbar-container">
        <v-btn text :style="spedlogo" class="spedlogo"></v-btn>

      <div class="flex-grow-1"></div>
      <!-- might be of use again
      <v-toolbar-items>
        <theme-picker/>
      </v-toolbar-items>-->
        <v-btn text class="elogbrand" :style="customelogbrand" @click="openElog"><i><font color="red">e</font></i>Log Kundenportal</v-btn>
      </v-toolbar-items>
    </v-app-bar>
</template>

<script>
/* import themePicker from '../components/devTools/opticsPicker' */
export default {
  components: {
    // themePicker
  },
  data () {
    return {
    }
  },
  beforeDestroy () {
  },
  mounted () {
  },
  computed: {
    spedlogo: function () {
      return {
        'background-image': 'url(' + this.$store.state.ttlinkoptics.spedLogo + ')'
      }
    },
    maincolor: function () {
      return this.$store.state.ttlinkoptics.mainColor
    },
    customelogbrand: function () {
      if (this.$store.state.ttlinkoptics.mainColor === '#ffffff' || this.$store.state.ttlinkoptics.mainColor === '#f3f2f2' || this.$store.state.ttlinkoptics.mainColor === '#e1e0e0') { return { 'color': '#000000 !important' } } else { return { 'color': '#ffffff !important' } }
    }
  },
  methods: {
    openElog: function () {
      window.open('https://elog.bdk.ch/Portal/?spednr=' + this.$store.state.ttlinkquerydata.bdkkenn)
    }
  }
}
</script>

<style>
  .elogbrand {
    text-transform: none !important;
  }
  .navbar {
    height: 80px !important;
    padding: 0px !important;
  }
  .navbar > .v-toolbar__content {
    padding: 0px !important;
  }
  .navbar-container {
    width: 75% !important;
    margin: auto;
    height: 80px !important;
  }

  .spedlogo {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    min-width: 200px !important;
    width: 200px !important;
    max-height: 100% !important;
}
</style>
